import {Mapper} from '@s-ui/domain'

export class HTTPNotificationsToUnseenSavedSearchMatchesMapper extends Mapper {
  constructor({config, unseenSavedSearchMatchesValueObject}) {
    super()
    this._config = config
    this._unseenSavedSearchMatchesValueObject = unseenSavedSearchMatchesValueObject
    this._defaultUnseenSavedSearches = this._config.get('notifications').DEFAULT_UNREAD_MESSAGES
  }

  map = ({data}) => {
    let matchCounters
    if (Array.isArray(data)) {
      matchCounters = data.reduce(
        (previousValue, currentValue) => previousValue + currentValue.counter,
        this._defaultUnseenSavedSearches
      )
    } else {
      matchCounters = data
    }

    return this._unseenSavedSearchMatchesValueObject({matchCounters})
  }
}
